import React from 'react';

/**
 * AssessmentStep2IndustrySelection
 *
 * Props:
 * - facilityInfo: object containing facility fields (including majorIndustry, subIndustry)
 * - handleInputChange: function(field) => event handler for controlled inputs
 * - availableSubIndustries: array of specialization strings for the selected major industry
 */
const AssessmentStep2IndustrySelection = ({
  facilityInfo,
  handleInputChange,
  availableSubIndustries
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6 mb-8">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
        Select Your Industry Specialization
      </h2>

      <div className="mb-6">
        <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg mb-6">
          <p className="text-blue-800 dark:text-blue-200">
            <strong>Selected Sector:</strong> {facilityInfo.majorIndustry}
          </p>
          <p className="text-sm text-blue-600 dark:text-blue-400 mt-1">
            Now please select your specific industry specialization within{' '}
            {facilityInfo.majorIndustry}.
          </p>
        </div>

        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Industry Specialization *
        </label>
        <select
          value={facilityInfo.subIndustry || ''}
          onChange={handleInputChange('subIndustry')}
          className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-emerald-700 dark:focus:ring-emerald-500"
        >
          <option value="">Select your specialization...</option>
          {availableSubIndustries && availableSubIndustries.length > 0
            ? availableSubIndustries.map((subIndustry) => {
                // Sub-industries have: id, major_industry, sub_industry, region
                // Use 'sub_industry' field (actual DB field) with 'name' as fallback
                const subIndustryName = subIndustry.sub_industry || subIndustry.name || '';
                const subIndustryId = subIndustry.id;
                return (
                  <option key={subIndustryId || subIndustryName} value={subIndustryName}>
                    {subIndustryName}
                  </option>
                );
              })
            : null}
        </select>

        {facilityInfo.subIndustry && (
          <div className="bg-emerald-50 dark:bg-emerald-900/20 p-4 rounded-lg mt-4">
            <p className="text-emerald-800 dark:text-emerald-200">
              <strong>✓ Selected:</strong> {facilityInfo.subIndustry}
            </p>
            <p className="text-sm text-emerald-600 dark:text-emerald-400 mt-1">
              Your assessment questions will be customized for {facilityInfo.subIndustry}{' '}
              operations.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssessmentStep2IndustrySelection;


